// Dependencies
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import Moment from "moment";
import _ from "lodash";
import DatePicker from "react-datepicker";

// Store
import {ActionCreator} from "../../../../actions/actions";
import {historyStoreSelectors} from "../../store/store";
import {HistoryActionCreators} from "../../actions/actionCreators";

// Elements
import Paginator from "../../../../utils/Paginator/Paginator.component";
import SearchUsers from "../SearchUsers/SearchUsers.component";

// Styles
import "./ActivityList.component.scss";
import "react-datepicker/dist/react-datepicker.css";

// Constants
const LOGS_PER_PAGE = 20;

const usersSearchHeader = (isLoading, onSearch) => {
    return (
        <SearchUsers
            key={"search-field"}
            onSearch={onSearch}
            isLoading={isLoading}
        />
    );
};
const usersItems = users => {
    let items = [];

    if (users.length > 0) {
        users.map(user => {
            items.push({
                label: (
                    <div>
                        {user.first_name} {user.last_name}
                    </div>
                ),
                value: user.id
            });
        });
    }

    return items;
};

const actionStringFormat = {
    ADD: (entity, name) =>
        name !== undefined
            ? `Created a new ${entity} - ${name}`
            : `Created a new ${entity}`,
    EDIT: (entity, name) =>
        name !== undefined
            ? `Edited a ${entity} - ${name}`
            : `Edited a ${entity}`,
    DELETE: (entity, name) =>
        name !== undefined
            ? `Deleted a ${entity} - ${name}`
            : `Deleted a ${entity}`
};

const entitiesDict = {
    GameCluster: "Game Cluster",
    KeyRequest: "Config. Key",
    GameConfiguration: "Game Config.",
    ProgressivePreset: "Progressive Preset",
    ServerSystemSpecs: "System Specification",
    MailingList: "Mailing List",
    Video: "Custom VPP",
    GameBundle: "Game Bundle",
    ProductType: "Product Type",
    SystemServerVersion: "System Server Version",
};

const entitiesDictName = {
    GameConfiguration: "label",
    Hall: "name",
    Server: "name",
    ProgressivePreset: "name",
    MailingList: "name",
    Game: "name",
    GameBundle: "name",
    Video: "name",
    Series: "name",
    Trademark: "name",
    Feature: "name",
    Platform: "name",
    ProductType: "name",
    Role: "name",
    Subsidiary: "dynamics_name",
    User: "first_name",
    SystemServerVersion: "version",
}

const entitiesDictLink = {
    Configuration: (use_changes, info, id) => {
        try {
            if (use_changes && info.filter(i => i.field == 'server')) {
                let url = window.location.origin;
                url += '/configurations/detail/' + info.filter(i => i.field == 'server')[0].new_value.hall_id + '/' + info.filter(i => i.field == 'server')[0].new_value.id + '/' + id;
                return url;
            }
            return null
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Server: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += use_changes && info.filter(i => i.field == 'hall_id') ? '/halls/' + info.filter(i => i.field == 'hall_id')[0].new_value + '/servers/' + id : '/halls/' + info.hall_id + '/servers/' + id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Hall: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += use_changes ? '/halls/' + id : '/halls/' + id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    ProgressivePreset: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            let type_id = use_changes ? info.filter(i => i.field == 'progressive_type_id')[0].new_value : info.progressive_type_id
            let isSpecialPrizes = type_id === 5 || type_id === 6
            url += isSpecialPrizes ? '/admin/special-prizes-presets' + '/detail/' + id : '/admin/progressives-presets' + '/detail/' + id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    MailingList: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/admin/mailing/detail/' + id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Game: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/game/' + id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    GameConfiguration: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            let game_id = use_changes ? info.filter(i => i.field == 'game_id')[0].new_value : info.game_id
            url += '/games/game/' + game_id;
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    GameBundle: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/bundles/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Series: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/attributes/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Trademark: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/attributes/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Feature: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/attributes/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    ProductType: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/attributes/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Platform: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/games/attributes/';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Video: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/vpp';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    Role: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/roles';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    User: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/users';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
    SystemServerVersion: (use_changes, info, id) => {
        try {
            let url = window.location.origin;
            url += '/admin/system-server-versions';
            return url;
        } catch (error) {
            console.log('Error in entitiesDictLink', error);
            return null;
        }
    },
};

export interface ActivityListProps extends RouteComponentProps {
    getActivityLogs: ActionCreator;
    activityLogsLoading: boolean;
    activityLogs: {
        results: any[];
        count: number;
    };
    getHistoryUsers: ActionCreator;
    historyUsersLoading: boolean;
    historyUsers: {
        results: any[];
        count: number;
    };
    currentActivitiesUsers: {
        results: any[];
        count: number;
    };
}

export interface ActivityListState {
    selectedEvent: number;
    selectedUsers: any[];
    currentPage: number;
    selectedRange: {
        start: string;
        end: string;
    };
}

class ActivityList extends Component<ActivityListProps, ActivityListState> {
    userFilter: React.RefObject<Components.SelectMenu>;
    eventFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.userFilter = React.createRef();
        this.eventFilter = React.createRef();

        const start = Moment().startOf("day").toISOString();
        const end = Moment().endOf("day").toISOString();

        this.state = {
            selectedEvent: null,
            selectedUsers: [],
            currentPage: 1,
            selectedRange: {
                start,
                end
            }
        };
        this.getActivityLogs();
    }

    getActivityLogs() {
        this.props.getActivityLogs({
            page: this.state.currentPage,
            top: LOGS_PER_PAGE,
            event: this.state.selectedEvent,
            users: this.state.selectedUsers.map(user => user.id),
            range: this.state.selectedRange
        });
    }

    getUsersToList = () => {
        let users =
            this.props.historyUsers.results.length == 0
                ? [...this.props.currentActivitiesUsers.results]
                : [...this.props.historyUsers.results];
        if (this.state.selectedUsers.length > 0)
            users = users.concat(this.state.selectedUsers);
        return _.uniqBy(users, "id");
    };


    applyFilters = (value, field) => {
        let updatedState = {...this.state};
        updatedState[field] = value
        if (field === 'start') {
            const start = Moment(value);
            updatedState.selectedRange.start = start.startOf("day").toISOString();
            if (start > Moment(this.state.selectedRange.end)) {
                updatedState.selectedRange.end = start.endOf("day").toISOString();
            }
        } else if (field === 'end') {
            const end = Moment(value);
            updatedState.selectedRange.end = end.endOf("day").toISOString();
            if (end < Moment(this.state.selectedRange.start)) {
                updatedState.selectedRange.start = end.startOf("day").toISOString();
            }
        } else if (field == 'selectedUsers') {
            updatedState[field] = _.filter(this.getUsersToList(), user => {
                return value.includes(user.id);
            });
        }
        this.setState({
            ...updatedState,
            currentPage: 1
        }, this.getActivityLogs)

    }
    pageChange = newPage => {
        this.setState({
            currentPage: newPage
        }, this.getActivityLogs);
    };

    onClearFilters = () => {
        this.userFilter.current.selectItem([]);
        this.userFilter.current.setDisplayString("Filter By Users...");
        this.eventFilter.current.selectItem([]);
        this.eventFilter.current.setDisplayString("Filter By Event...");

        const start = Moment().startOf("day").toISOString();
        const end = Moment().endOf("day").toISOString();

        if (this.userFilter.current) {
            this.userFilter.current.setState({
                id: _.uniqueId()
            });
        }

        this.setState({
            selectedEvent: null,
            selectedUsers: [],
            currentPage: 1,
            selectedRange: {
                start,
                end
            }
        });
    };

    onUserSearch = search => {
        if (search.length > 3) {
            this.props.getHistoryUsers(search);
        } else {
            this.props.getHistoryUsers(null);
        }
    };

    renderFilters() {
        const range = {
            start: new Date(this.state.selectedRange.start),
            end: new Date(this.state.selectedRange.end)
        };
        const userItems = usersItems(this.getUsersToList());
        return (
            <div className="row">
                <div className="col-12">
                    <div className="history-filters">
                        <div id="HistoryPageFiltersBox">
                            <div className="row">
                                <div className="adjustable-filters">
                                    <div className="history-filter">
                                        <label className="label">
                                            Users
                                        </label>
                                        <Components.SelectMenu
                                            ref={this.userFilter}
                                            items={userItems}
                                            noValueLabel="Filter By Users..."
                                            multipleSelection
                                            headerContainer={usersSearchHeader(
                                                this.props
                                                    .historyUsersLoading,
                                                this.onUserSearch
                                            )}
                                            value={
                                                this.state.selectedUsers
                                                    .length > 0
                                                    ? this.state.selectedUsers.map(
                                                        user =>
                                                            user.id
                                                    )
                                                    : null
                                            }
                                            onChange={event => this.applyFilters(event, 'selectedUsers')}
                                        />
                                    </div>

                                    <div className="history-filter">
                                        <label className="label">
                                            Events
                                        </label>
                                        <Components.SelectMenu
                                            ref={this.eventFilter}
                                            items={[
                                                {
                                                    value: "ADD",
                                                    label: "Created"
                                                },
                                                {
                                                    value: "EDIT",
                                                    label: "Edited"
                                                },
                                                {
                                                    value: "DELETE",
                                                    label: "Deleted"
                                                }
                                            ]}
                                            noValueLabel="Filter By Event..."
                                            value={this.state.selectedEvent}
                                            onChange={event => this.applyFilters(event, 'selectedEvent')}
                                        />
                                    </div>

                                    <div className="history-filter">
                                        <label className="label">
                                            Date Range
                                        </label>
                                        <div className="date-range">
                                            <DatePicker
                                                selected={range.start}
                                                onChange={event => this.applyFilters(event, 'start')}
                                                selectsStart
                                                className={`read-only input date-input`}
                                                startDate={range.start}
                                                endDate={range.end}
                                            />
                                            <div className="range-icon">
                                                <i className="icon-arrow-right-light"/>
                                            </div>
                                            <DatePicker
                                                selected={range.end}
                                                onChange={event => this.applyFilters(event, 'end')}
                                                selectsEnd
                                                startDate={range.start}
                                                endDate={range.end}
                                                className={`read-only input date-input`}
                                                minDate={range.start}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <button
                                            className="clear-filters-btn"
                                            onClick={
                                                this.onClearFilters
                                            }
                                        >
                                            Clear All Filters
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderActivities() {
        if (this.props.activityLogs.results.length === 0) {
            return (
                <div className="activity-list-no-activities">
                    No activity records to display. Please select different
                    values to try again.
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="activities-container">
                        <table>
                            <thead>
                            <tr>
                                <td colSpan={2}>Users</td>
                                <td>Events</td>
                                <td className="activity-date">Date</td>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.activityLogs.results.map(
                                (log, key) => {
                                    return this.renderRow(log, key);
                                }
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="paginator-col">
                        <Paginator
                            currentPage={this.state.currentPage}
                            totalPages={
                                Math.floor(this.props.activityLogs.count / 24) +
                                1
                            }
                            onPageChange={this.pageChange}
                        />
                    </div>
                </React.Fragment>
            )
        }
    }

    renderRow(log, key) {
        const type = entitiesDict.hasOwnProperty(log.entity_type)
            ? entitiesDict[log.entity_type]
            : log.entity_type;
        const name = log.action === "ADD" ?
            (entitiesDictName.hasOwnProperty(log.entity_type) && log.additional_info.changes.filter(c => c.field == entitiesDictName[log.entity_type]).length > 0 ? log.additional_info.changes.filter(c => c.field == entitiesDictName[log.entity_type])[0].new_value : undefined)
            : (log.entity_state && entitiesDictName.hasOwnProperty(log.entity_type) ? log.entity_state[entitiesDictName[log.entity_type]] : undefined);
        let link
        if (entitiesDictLink.hasOwnProperty(log.entity_type) && log.entity_id != null && log.action !== "DELETE") {
            link = entitiesDictLink[log.entity_type](log.action === "ADD", log.action === "ADD" ? log.additional_info.changes : log.entity_state, log.entity_id);
        }
        return (
            <tr key={key} className={"with-detail"}>
                <td className="activity-user-image">
                    {log.event_user && (
                        <React.Fragment>
                            {(log.event_user.profile_picture_base64 == "" ||
                                !log.event_user.profile_picture_base64) && (
                                <div className="user-icon">
                                    <i className="icon-user-light"/>
                                </div>
                            )}
                            {log.event_user.profile_picture_base64 &&
                                log.event_user.profile_picture_base64 !== ""
                                 && (
                                    <div
                                        style={{
                                            backgroundImage: log.event_user.profile_picture_base64.includes('data:image/png;base64')
                                                ? `url('${log.event_user.profile_picture_base64}')`
                                                : `url('data:image;base64,${log.event_user.profile_picture_base64}')`
                                        }}
                                    />
                                )}
                        </React.Fragment>
                    )}
                </td>
                <td className="activity-user">
                    {log.event_user && (
                        <React.Fragment>
                            {`${log.event_user.first_name} ${log.event_user.last_name}`}
                        </React.Fragment>
                    )}
                </td>
                <td className="activity-activities">
                    <p>{actionStringFormat[log.action](type, name)}</p>
                    {link &&
                        (<div>
                            <a href={link}>{link}</a>
                        </div>)
                    }

                    <div className="edit-detail">
                        <span className="expand open"/>
                        <ul>
                            {log.action === "ADD" ?
                                log.additional_info.changes.map(c => {
                                    return (
                                        <li>
                                            <span className="field-title">
                                                {c.field.split('_').map(t => t[0].toUpperCase() + t.substring(1)).join(' ')}
                                                :{" "}
                                            </span>
                                            <br/>
                                            <span className="new-value" onClick={e => {
                                                const target = e.target as HTMLTextAreaElement;
                                                target.classList.toggle('new-value-show');
                                            }}>
                                                  {JSON.stringify(c.new_value)}
                                            </span>
                                        </li>
                                    )
                                })
                                : log.action === "EDIT" ?
                                    log.additional_info.changes.map(c => {
                                        return (
                                            <li onClick={e => {
                                                for (let i = 0; i < e.currentTarget.childNodes.length; i++) {
                                                    const c = e.currentTarget.childNodes[i] as HTMLTextAreaElement;
                                                    if (c.classList.contains('new-value')) {
                                                        c.classList.toggle('new-value-show')
                                                    } else if (c.classList.contains('old-value')) {
                                                        c.classList.toggle('old-value-show')
                                                    } else if (c.classList.contains('change')) {
                                                        c.classList.toggle('change-show')
                                                    }
                                                }
                                            }}>
                                                <span className="field-title">
                                                    {c.field.split('_').map(t => t[0].toUpperCase() + t.substring(1)).join(' ')}
                                                    :{" "}
                                                </span>
                                                <br/>
                                                <span className="old-value">
                                                  {JSON.stringify(c.old_value)}
                                                </span>
                                                <span className="change">
                                                    <i className="icon-chevron-right-light"/>
                                                </span>
                                                <span className="new-value">
                                                  {JSON.stringify(c.new_value)}
                                                </span>
                                            </li>
                                        )
                                    })
                                    : Object.keys(log.entity_state ? log.entity_state : log.additional_info).map(c => {
                                        return (
                                            <li>
                                                <span className="field-title">
                                                    {c.split('_').map(t => t[0].toUpperCase() + t.substring(1)).join(' ')}
                                                    :{" "}
                                                </span>
                                                <br/>
                                                <span className="old-value" onClick={e => {
                                                    const target = e.target as HTMLTextAreaElement;
                                                    target.classList.toggle('old-value-show');
                                                }}>
                                                    {JSON.stringify(log.entity_state ? log.entity_state[c] : log.additional_info[c])}
                                                </span>
                                            </li>
                                        )
                                    })
                            }
                        </ul>
                    </div>
                </td>
                <td className="activity-date">
                    {Moment(new Date(log.event_time)).format("DD MMM YYYY @ HH:mm:ss")}
                </td>
            </tr>
        )
    }

    render() {
        return (
            <div id="ActivityLogsList" className="content">
                <div className="container">
                    {this.renderFilters()}
                    <div className="activity-list">
                        {this.props.activityLogsLoading ? (
                            <div className="activity-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="activities row">
                                {this.renderActivities()}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    activityLogs: historyStoreSelectors.activityLogs(state),
    activityLogsLoading: historyStoreSelectors.activityLogsLoading(state),
    historyUsers: historyStoreSelectors.historyUsers(state),
    historyUsersLoading: historyStoreSelectors.historyUsersLoading(state),
    currentActivitiesUsers: historyStoreSelectors.currentActivitiesUsers(state)
});

const mapDispatchToProps = {
    getActivityLogs: HistoryActionCreators.getActivityLogs,
    getHistoryUsers: HistoryActionCreators.getHistoryUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActivityList));
